import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from './axiosInstance';

const ProtectedRoute = ({ children }) => {
  const currentUser = getCurrentUser();
  return currentUser ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
